import React from "react";
import { put } from "../../../../utils/api";
import GenericViewDrawer1 from "../../GenericViewDrawer1";

const ViewDetailsDrawerRenewableEnergy = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    {
      label: "Consumption Period",
      previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
      requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
        data?.editValue?.consumptionPeriod?.year || "—"
      }`,
    },
    {
      label: "Type of Renewable Energy",
      previous: data?.typeOfRenewableEnergy || "—",
      requested: data?.editValue?.typeOfRenewableEnergy || "—",
    },
    {
      label: "Importer",
      previous: data?.importer || "—",
      requested: data?.editValue?.importer || "—",
    },
    {
      label: "Energy Exported (MWh)",
      previous: data?.energyExported?.toLocaleString() || "—",
      requested: data?.editValue?.energyExported?.toLocaleString() || "—",
    },
    {
      label: "Emission Factor (tCO₂e/MWh)",
      previous: data?.emissionFactor?.toLocaleString() || "—",
      requested: data?.editValue?.emissionFactor?.toLocaleString() || "—",
    },
    // {
    //   label: "Total Emission (tCO₂e)",
    //   previous: data?.totalEmission?.toLocaleString() || "—",
    //   requested: data?.editValue?.totalEmission?.toLocaleString() || "—",
    // },
    {
      label: "Remarks",
      previous: data?.remarks || "—",
      requested: data?.editValue?.remarks || "—",
    },
    {
      label: "Edit Remark Reason",
      previous: data?.editRemarkReason || "—",
      requested: data?.editValue?.editRemarkReason || "—",
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Renewable Energy Export Avoidance Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default ViewDetailsDrawerRenewableEnergy;
